import { Platform } from "react-native";
import Constants from "expo-constants";
import mixpanel from "mixpanel-browser";

const mixpanelProjectToken = (Constants.expoConfig?.extra?.mixpanelProjectToken as string) || "";

if (Platform.OS === "web" && mixpanelProjectToken) {
    mixpanel.init(mixpanelProjectToken, {
        api_host: "https://api-eu.mixpanel.com",
    });
}
export const identify = (userId: string) => {
    if (Platform.OS === "web" && mixpanelProjectToken) {
        mixpanel.identify(userId);
    }
};
